import NotificationHistory from "./NotificationHistory";
export default NotificationHistory;